export type PaymentType = {
    id: number,
    description: string
}

export const PaymentTypes: PaymentType[] = [
    {description: 'Check', id: 0},
    {description: 'Cash', id: 1},
    {description: 'Card', id: 2},
    {description: 'Bank Wire', id: 3}
]

export type Payment = {
    id: number,
    amount: number,
    details: string,
    payerId: number,
    paymentType: number,
    invoiceId: number
}

export const DefaultPayment: Payment = {
    id: 0,
    amount: 0,
    payerId: 0,
    invoiceId: 0,
    details: '',
    paymentType: 0
}